import { render, staticRenderFns } from "./news.vue?vue&type=template&id=6f695832&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f695832')) {
      api.createRecord('6f695832', component.options)
    } else {
      api.reload('6f695832', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=6f695832&", function () {
      api.rerender('6f695832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/news.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/news.vue
// module id = 85
// module chunks = 0